import $ from "jquery";
import _ from "lodash";
import { subscribe as $subscribe } from "../../../../events/jQuerySubscription";
import { EventEmitter } from "../../../../events/eventEmitter";
class ButtonProvider extends EventEmitter {
    constructor(id) {
        super();
        this.container = $();
        this.canSubmit = false;
        this.id = id;
    }
    initialise(_setSelected, container, label) {
        this.container = container;
        const button = this.getButton();
        button.removeClass("hidden");
        if (_.some(label)) {
            const labelId = label.attr("id") || `ButtonProvider_label_${this.id}`;
            const buttonId = `ButtonProvider_button_${this.id}`;
            label.attr("id", labelId);
            button.attr("id", buttonId);
            button.attr("aria-labelledby", `${labelId} ${buttonId}`);
        }
    }
    setName(name) {
        this.getButton().prop("name", name);
    }
    enable() {
        this.getButton().prop("disabled", false);
    }
    disable() {
        this.getButton().prop("disabled", true);
    }
    setDisplayText(text) {
        this.getButton()
            .children()
            .first()
            .html(text || "");
    }
    focus() {
        this.getButton().trigger("focus");
    }
    hasFocus() {
        return this.getButton().is(":focus");
    }
    set ariaExpanded(value) {
        this.getButton().attr("aria-expanded", value);
    }
    cleanUp() { }
    get searchElement() {
        return undefined;
    }
    getButton() {
        return this.container.find("[data-custom-select-button]");
    }
}
class ButtonProviderFactory {
    constructor() {
        this.uniqueId = 0;
    }
    make() {
        return new ButtonProvider(this.uniqueId++);
    }
}
export const buttonProviderFactory = new ButtonProviderFactory();
export class TextInputProvider extends EventEmitter {
    constructor() {
        super(...arguments);
        this.container = $();
        this.setSelected = () => { };
        this.subscriptions = [];
        this.canSubmit = true;
    }
    initialise(setSelected, container, label) {
        this.setSelected = setSelected;
        this.container = container;
        const textInput = this.getTextInput();
        textInput.removeClass("hidden");
        if (_.some(label))
            textInput.attr("aria-label", label.text());
        this.subscriptions.push($subscribe(textInput, "input", () => {
            const value = textInput.val();
            this.setSelected({ displayName: value, selected: true });
        }), $subscribe(textInput, "blur", () => this.emit("blur")));
    }
    setName(name) {
        this.getTextInput().prop("name", name);
    }
    enable() {
        this.getTextInput().prop("disabled", false);
    }
    disable() {
        this.getTextInput().prop("disabled", true);
    }
    setDisplayText(text) {
        this.getTextInput().val(text || "");
    }
    focus() {
        this.getTextInput().trigger("focus");
    }
    hasFocus() {
        return this.getTextInput().is(":focus");
    }
    set ariaExpanded(value) {
        this.getTextInput().attr("aria-expanded", value);
    }
    cleanUp() { }
    get searchElement() {
        return this.getTextInput();
    }
    getTextInput() {
        return this.container.find("[data-custom-select-text-input]");
    }
}
